import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '../../stores/authStore';
import { useSidebarStore } from '../../stores/sidebarStore';

export const AdminLayout: React.FC = () => {
    const { isAuthenticated } = useAuthStore();
    const { toggleSidebar } = useSidebarStore();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="flex h-screen bg-background-page overflow-hidden">
            <Sidebar />

            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                {/* Main Content Area */}
                <button onClick={toggleSidebar} className="md:hidden absolute top-4 left-4 z-50 p-2 bg-white/80 backdrop-blur rounded-full shadow-sm text-neutral-600">
                    <span className="sr-only">Toggle Sidebar</span>
                    <span className="w-6 h-6" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_e5651b11.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_e5651b11.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
                </button>

                {/* Main Content Area */}
                <main className="flex-1 overflow-auto p-1 md:p-2">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};
